import * as React from 'react';
import { observer } from 'mobx-react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { TagCheckbox } from '../TagCheckbox';
import { Tag, RenderedTagType } from '../../../../../models/hotel-reviews';
import S from '../../../../../stores';

export interface InterestsFilterProps {
    availableTags: Tag[];
    sortedTagsByReviewAmount: Array<RenderedTagType>;
}

interface InterestsFilterState {
    showMoreTags: boolean;
    renderedTags: Array<RenderedTagType>;
}

interface StyledInterestsFilterProps
    extends InterestsFilterProps,
            JSSClassesProps<ComponentJSSClasses> {}

@observer
export class InterestsFilter extends React.Component<StyledInterestsFilterProps, InterestsFilterState> {
    constructor(props: StyledInterestsFilterProps) {
        super(props);
        this.state = {
            showMoreTags: false,
            renderedTags: this.sliceRenderedTags(props.sortedTagsByReviewAmount)
        };
    }

    isChecked = (interest: number): boolean =>
        S.hotelReviews.interestsFilter.includes(interest)

    handleChange = (interest: number) => {
        S.hotelReviews.setInterestsFilter(interest);
    }

    handleShowMoreTags = () => {
        this.setState({
            showMoreTags: true,
            renderedTags: [...this.props.sortedTagsByReviewAmount]
         } );
    }

    handleHideMoreTags = () => {
        this.setState({
            showMoreTags: false,
            renderedTags: this.sliceRenderedTags(this.props.sortedTagsByReviewAmount)
         } );
    }

    render() {
        const { classes, availableTags } = this.props;

        return (
            <div className={classes.container}>
                {this.state.renderedTags?.map((currentTag: RenderedTagType) => {
                    const tagKeyId = Number(currentTag[0]);
                    const tag = availableTags.find(availableTag => availableTag.id === tagKeyId);

                    if (!tag) return null;

                    return (
                    <TagCheckbox
                        inputName={tag.displayName}
                        label={tag.id}
                        checked={this.isChecked(tag.id)}
                        onChange={this.handleChange}
                        key={`tag_${tag.id}`}
                    />
                ); })}

                { this.state.showMoreTags ? (
                    <button
                        className={classes.showMoreTags}
                        type="button"
                        onClick={this.handleHideMoreTags}
                    >
                        Скрыть
                    </button>
                    ) : (
                    <button
                        className={classes.showMoreTags}
                        type="button"
                        onClick={this.handleShowMoreTags}
                    >
                        Показать ещё
                    </button>
                    )
                }
            </div>
        );
    }

    private sliceRenderedTags = (tags: Array<any>): Array<any> => {
        const VISIBLE_TAGS = 10;
        return tags.slice(0, VISIBLE_TAGS);
    }
}
